export default __webpack_public_path__ + "static/media/ar.d5ff2fb7.svg";